import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { phoneNumberSchema } from '@zaoblako/shared/modules/serde/schemas/phone-number.schema';
import { emailSchema } from '@zaoblako/shared/modules/serde/schemas/email.schema';

import * as yup from 'yup';

/** Mailing file debtor create and update APIs body - DTO signature */
export interface MailingFileDebtorTargetFormInterface {
  /** Counterparty name (first column from Excel file) */
  name: string;
  /** Counterparty phone number (second column from Excel file, for SMS mailings) */
  phone?: string;
  /** Counterparty email address (third column from Excel file, for email mailings) */
  email?: string;
  /** Debt amount value (fourth column from Excel file) */
  amount: number;
}

/** Mailing file debtor create and update APIs body - DTO schema */
export const MailingFileDebtorTargetFormDto = SerdeDtoClass.create<MailingFileDebtorTargetFormInterface>(
  NotificationDtoKeysEnum.MAILING_FILE_DEBTOR_TARGET_FORM_DTO,
  {
    name: {
      label: 'Имя получателя',
      serializer: nonEmptyStringSchema,
    },
    phone: {
      optional: true,
      label: 'Телефон',
      serializer: phoneNumberSchema,
    },
    email: {
      optional: true,
      label: 'E-Mail',
      serializer: emailSchema,
    },
    amount: {
      label: 'Сумма долга',
      serializer: yup.number(),
    },
  },
);
